
import collect from 'collect.js'

export default {
  asyncData({ app, i18n, query, $config: { baseURL } }) {
    const title = i18n.t('Amsterdam')
    const path = 'hotels-places-nl-amsterdam'
    const image = '/images/places/amsterdam.jpg'

    let checkIn = app.$moment().locale('en').format('YYYY-MM-DD')
    let checkOut = app
      .$moment()
      .locale('en')
      .add(1, 'days')
      .format('YYYY-MM-DD')
    let guests = [{ adults: 2, children: [] }]

    if (
      query.check_in &&
      query.check_in >= app.$moment().locale('en').format('YYYY-MM-DD')
    ) {
      checkIn = app.$moment(query.check_in).locale('en').format('YYYY-MM-DD')
      if (query.check_out && query.check_out > query.check_in) {
        if (
          app
            .$moment(query.check_out)
            .diff(app.$moment(query.check_in), 'days') > 30
        ) {
          checkOut = app
            .$moment(checkIn)
            .locale('en')
            .add(30, 'days')
            .format('YYYY-MM-DD')
        } else {
          checkOut = app
            .$moment(query.check_out)
            .locale('en')
            .format('YYYY-MM-DD')
        }
      } else {
        checkOut = app
          .$moment(query.check_in)
          .locale('en')
          .add(1, 'days')
          .format('YYYY-MM-DD')
      }
    }

    if (query.check_out && query.check_out > checkIn) {
      if (
        app.$moment(query.check_out).diff(app.$moment(checkIn), 'days') > 30
      ) {
        checkOut = app
          .$moment(checkIn)
          .locale('en')
          .add(30, 'days')
          .format('YYYY-MM-DD')
      } else {
        checkOut = app
          .$moment(query.check_out)
          .locale('en')
          .format('YYYY-MM-DD')
      }
    }

    if (query.guests) {
      guests = query.guests.split('|').map((r) => {
        return {
          adults: r.split(',').filter((v) => v === 'a').length,
          children: r.split(',').filter((v) => v > 0),
        }
      })
    }

    return {
      title,
      path,
      image,
      aggregator: 'travolutionary',
      destination: {
        type: 'place',
        id: 'ChIJVXealLU_xkcRja_At0z9AGY',
        name: 'אמסטרדם',
        title: 'אמסטרדם',
        types: ['locality', 'political'],
        query_type: 'destination',
        _geoloc: {
          lat: 52.3675734,
          lng: 4.9041389,
        },
      },
      start: checkIn,
      end: checkOut,
      rooms: guests,
      schemaBreadcrumbList: {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: i18n.t('Travelor'),
            item: baseURL + app.localePath('/'),
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: i18n.t('Hotels'),
            item: baseURL + app.localePath('hotels'),
          },
          {
            '@type': 'ListItem',
            position: 4,
            name: i18n.t('Hotels in {destination}', {
              destination: title,
            }),
            item:
              baseURL +
              app.localePath({
                name: path,
              }),
          },
        ],
      },
    }
  },

  head() {
    return {
      title: this.$i18n.t('Hotels in {destination}', {
        destination: this.title,
      }),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t(
            'Competitive prices, personal and professional service in booking hotels, flights and other tourism products.',
          ),
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('Hotels in {destination}', {
            destination: this.title,
          }),
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.$i18n.t('Hotels in {destination}', {
            destination: this.title,
          }),
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.$i18n.t(
            'Competitive prices, personal and professional service in booking hotels, flights and other tourism products.',
          ),
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.schemaBreadcrumbList),
          type: 'application/ld+json',
        },
      ],
    }
  },

  created() {
    if (this.searches) {
      const last = collect(this.searches).last(
        (item) => item.aggregator === this.aggregator,
      )

      if (last) {
        this.start = last.params.check_in
        this.end = last.params.check_out
        this.rooms = last.params.guests.split('|').map((r) => {
          return {
            adults: r.split(',').filter((v) => v === 'a').length,
            children: r.split(',').filter((v) => v > 0),
          }
        })
      }
    }
  },
}
